import { useRegisterSW } from 'virtual:pwa-register/react';
import { useEffect } from 'react';
import { useGameStore } from '../state/store';

export function PwaPrompt(): JSX.Element | null {
  const phase = useGameStore((state) => state.phase);
  const {
    needRefresh: [needRefresh, setNeedRefresh],
    offlineReady: [offlineReady, setOfflineReady],
    updateServiceWorker,
  } = useRegisterSW();

  useEffect(() => {
    if (!offlineReady) return;
    const timer = window.setTimeout(() => setOfflineReady(false), 3200);
    return () => clearTimeout(timer);
  }, [offlineReady, setOfflineReady]);

  // Kein Toast und vor allem kein harter Reload waehrend des Fahrens. Ein
  // bereitstehendes Update bleibt gespeichert und erscheint in Home/Pause.
  if (phase === 'playing' || (!needRefresh && !offlineReady)) return null;
  return (
    <div className="pwa-toast" role="status">
      <span>{needRefresh ? 'NEUE VERSION BEREIT' : 'JETZT OFFLINE SPIELBAR'}</span>
      {needRefresh && (
        <button type="button" onClick={() => void updateServiceWorker(true)}>LADEN</button>
      )}
      <button
        type="button"
        aria-label="Hinweis schließen"
        onClick={() => { setNeedRefresh(false); setOfflineReady(false); }}
      >×</button>
    </div>
  );
}
